import { defineMessages } from '@cookbook/solid-intl'

// Split out from the page's own messages file so the router's document-title /
// meta-description wiring doesn't pull a whole page catalogue into the
// boot-critical chunk just for these two strings. Same pattern as
// `browser-extension-landing-page-routing.messages.en.js` (TENANT-5036).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Internal demo of the Lodgr browser extension running through the gateway.',
        id: 'BrowserDemoPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Browser Extension Demo | Lodgr',
        id: 'BrowserDemoPage.titleMessage',
    }),
}
